const SITE_URL = 'https://bloomclinicwomen.com';

export const INDEXABLE_ROBOTS =
  'index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1';
export const NOINDEX_ROBOTS = 'noindex,nofollow,noarchive';

function getSiteUrl() {
  return SITE_URL;
}

function normalizePath(path: string) {
  if (!path || path === '/') {
    return '/';
  }

  return path.startsWith('/') ? path : `/${path}`;
}

function setMetaContent(selector: string, content: string) {
  const element = document.querySelector(selector);
  if (element) {
    element.setAttribute('content', content);
  }
}

export function applyStructuredData() {
  if (typeof document === 'undefined') {
    return;
  }

  const siteUrl = getSiteUrl();
  const name = 'Bloom Clinic Morocco';
  const description = 'Aesthetic, body care, skincare, slimming, laser and wellness treatments for women in Morocco.';
  const services = ['Body Care', 'Slimming', 'HydraFacial', 'Laser Epilation', 'Skincare', 'Teeth Whitening'];
  const socialLinks = ['https://www.instagram.com/bloomclinicwomen/', 'https://web.facebook.com/BloomClinicWomen'];

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'MedicalBusiness',
    '@id': `${siteUrl}/#business`,
    name,
    url: `${siteUrl}/`,
    description,
    image: `${siteUrl}/bloom_clinic_logo.png`,
    telephone: '+212662251047',
    priceRange: '$$',
    areaServed: {
      '@type': 'Country',
      name: 'Morocco',
    },
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: '303 Bd Brahim Roudini',
        addressLocality: 'Casablanca',
        addressCountry: 'MA',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: '7 Rue Assindiane, Secteur 10, Hay Riad',
        addressLocality: 'Rabat',
        addressCountry: 'MA',
      },
    ],
    sameAs: socialLinks,
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Clinic treatments',
      itemListElement: services.map((service) => ({
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: service,
          provider: { '@id': `${siteUrl}/#business` },
        },
      })),
    },
  };

  const scriptId = 'site-jsonld';
  const script = document.getElementById(scriptId) || document.createElement('script');
  script.id = scriptId;
  script.setAttribute('type', 'application/ld+json');
  script.textContent = JSON.stringify(structuredData);
  if (!script.parentElement) {
    document.head.appendChild(script);
  }
}

export function applySeo(options: {
  title?: string;
  description?: string;
  robots?: string;
  path?: string;
}) {
  if (typeof document === 'undefined') {
    return;
  }

  if (options.title) {
    document.title = options.title;
  }

  if (options.description) {
    setMetaContent('meta[name="description"]', options.description);
    setMetaContent('meta[property="og:description"]', options.description);
    setMetaContent('meta[name="twitter:description"]', options.description);
  }

  if (options.robots) {
    setMetaContent('meta[name="robots"]', options.robots);
  }

  if (options.path !== undefined) {
    const canonicalPath = normalizePath(options.path);
    const canonicalUrl = `${getSiteUrl()}${canonicalPath}`;

    const canonicalElement = document.querySelector('link[rel="canonical"]');
    if (canonicalElement) {
      canonicalElement.setAttribute('href', canonicalUrl);
    }

    setMetaContent('meta[property="og:url"]', canonicalUrl);
  }
}
